import type { ReactNode } from "react";
import { MarketingHeader } from "./MarketingHeader";

export function MarketingShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-[#F6F3EC] font-sans text-[#111827] antialiased selection:bg-[#2B3624] selection:text-[#F6F3EC]">
      <div className="pointer-events-none fixed inset-0 z-50 hidden justify-center lg:flex">
        <div className="relative h-full w-full max-w-[1400px] border-x border-[#2B3624]/[0.06]">
          <div className="absolute -left-1 top-0 h-1.5 w-1.5 border border-[#2B3624]/20 bg-[#F6F3EC]" />
          <div className="absolute -right-1 top-0 h-1.5 w-1.5 border border-[#2B3624]/20 bg-[#F6F3EC]" />
          <div className="absolute -left-1 top-24 h-1.5 w-1.5 border border-[#2B3624]/20 bg-[#F6F3EC]" />
          <div className="absolute -right-1 top-24 h-1.5 w-1.5 border border-[#2B3624]/20 bg-[#F6F3EC]" />
        </div>
      </div>

      <div className="relative mx-auto flex min-h-0 w-full max-w-[1400px] flex-1 flex-col px-5 sm:px-8 lg:px-12 xl:px-16">
        <MarketingHeader />
        <main className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain pb-[env(safe-area-inset-bottom)]">
          {children}
        </main>
      </div>
    </div>
  );
}
